import { MessageCircle, RotateCw, Star, Video } from "lucide-react";
import { Btn } from "./Btn";
import { Eyebrow } from "./Typo";

const AGENTS = [
  [MessageCircle, "Agent WhatsApp", "Répond à vos clients 24 h/24, qualifie les demandes et prend rendez-vous.", "cyan"],
  [RotateCw, "Agent relance", "Relance automatiquement les devis sans réponse et les paniers abandonnés.", "magenta"],
  [Star, "Agent avis", "Demande un avis Google après chaque vente pour booster votre réputation.", "amber"],
  [Video, "Prospection vidéo", "Envoie des propositions vidéo personnalisées à vos prospects.", "violet"],
];

export const SalesAgents = () => (
  <section className="section agents" aria-labelledby="agents-title" data-testid="home-sales-agents">
    <div className="section-head" data-reveal>
      <Eyebrow>VOTRE ÉQUIPE COMMERCIALE IA</Eyebrow>
      <h2 id="agents-title">Des agents qui vendent <span className="grad-text">pendant que vous dormez.</span></h2>
    </div>
    <div className="agent-grid">
      {AGENTS.map(([Icon, t, d, c], i) => (
        <article key={t} className="agent-card spot" data-reveal style={{ "--d": `${i * 80}ms`, "--c": `var(--${c})` }} data-testid={`sales-agent-${i}`}>
          <div className="agent-head"><span className="agent-ico"><Icon size={20} aria-hidden="true" /></span>
            <em className="agent-pill"><i aria-hidden="true" />Actif</em></div>
          <h3>{t}</h3><p>{d}</p>
          <span className="agent-pulse" aria-hidden="true" />
        </article>
      ))}
    </div>
    <div className="agents-foot" data-reveal>
      <p className="muted" data-testid="sales-agents-control">Toujours sous votre contrôle : validation humaine sur ce qui compte.</p>
      <Btn to="/contact/?offre=agents#projet" testid="sales-agents-cta">Parler de mon projet</Btn>
    </div>
  </section>
);

const CLIENTS = [["Client A", "Nouveau"], ["Entreprise B", "Devis vu"], ["Commerce C", "Audit prêt"], ["Boutique D", "À relancer"], ["Société E", "Client"]];
const TABS = ["Fiche", "Audit", "Devis", "Suivi", "Rapports"];
const ROWS = [["Audit automatique", "Terminé"], ["Devis animé envoyé", "Vu"], ["Prochaine relance", "Planifiée"]];

const StudioMockup = () => (
  <div className="studio-app" role="img" aria-label="Exemple de logiciel commercial sur mesure : liste de clients et fiche client" data-testid="studio-mockup">
    <div className="studio-in" aria-hidden="true">
      <aside className="studio-list">
        <b>Clients</b>
        {CLIENTS.map(([n, s], i) => <div key={n} className={`studio-client ${i === 1 ? "is-on" : ""}`}><i />{n}<em>{s}</em></div>)}
      </aside>
      <div className="studio-card">
        <div className="studio-tabs">{TABS.map((t, i) => <span key={t} className={i === 0 ? "is-on" : ""}>{t}</span>)}</div>
        <div className="studio-hd">
          <div><b>Entreprise B</b><span>Fiche prospect</span></div>
          <svg className="studio-gauge" viewBox="0 0 80 80"><circle cx="40" cy="40" r="32" /><circle className="g" cx="40" cy="40" r="32" pathLength="100" /><text x="40" y="46">82</text></svg>
        </div>
        {ROWS.map(([l, s], i) => <div key={l} className="studio-row" style={{ "--i": i }}><i />{l}<em>{s}</em></div>)}
      </div>
    </div>
  </div>
);

export const StudioSection = () => (
  <section className="section studio" aria-labelledby="studio-title" data-testid="home-studio">
    <div className="studio-grid">
      <div data-reveal>
        <Eyebrow>VOS OUTILS SUR MESURE</Eyebrow>
        <h2 id="studio-title">Votre propre <span className="grad-text">studio commercial.</span></h2>
        <p className="lead">Fiches prospects, audits automatiques, devis animés, suivi des clients et rapports : un logiciel à vos couleurs, pour que votre équipe vende plus, plus vite.</p>
        <div className="actions"><Btn to="/contact/?offre=studio#projet" testid="studio-cta">Voir une démo</Btn></div>
      </div>
      <div data-reveal style={{ "--d": "120ms" }}><StudioMockup /></div>
    </div>
  </section>
);
